import { adminHttpClient } from '../../../../commons/adminHttpClient'
import { BaseProductClassValues } from './baseProductClass'
import { FamilyStatus } from 'domain/companies/familyStatus'

export interface CostSharingAmountValues extends BaseProductClassValues {
  deductable: boolean | null
  deductibleAmount: DeductableAmountValue[]
}

export interface DeductableAmountValue {
  familyStatusId: FamilyStatus
  amount: number
}

const costSharingAmountApi = (CostSharingAmountValues: CostSharingAmountValues): Promise<any> => {
  return adminHttpClient.put('/AdminDashboard/ClassDesign/CostSharingAmount', CostSharingAmountValues)
}

export default costSharingAmountApi
